import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getPlanzoneResources(planzone)
        .then((resources) => ({ planzone, resources })),
    );
}

export type { Interactor };

export { createInteractor };
